<script>
import {
    eventGroupState, isSelectedEventGroupLocked
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import { createEventDispatcher } from 'svelte';
import { toast } from '@zerodevx/svelte-toast';
import * as m from "@app/paraglide/messages.js";
const dispatch = createEventDispatcher();
let isLocked = $derived(isSelectedEventGroupLocked());

function markEvents() {
    try {
        if (isSelectedEventGroupLocked()) {
            toast.push(m.event_group_locked_toast(), { classes: ["toast-warning"] });
            return;
        }

        eventGroupState[projectState.selected].selected.forEach(selectedEventIndex => {
            eventGroupState[projectState.selected].events[selectedEventIndex].forced = true;
        });

        insertHistoryAction({
            name: "forced events", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
}
</script>

<a id="btnForcedSubtitle"
    class="dropdown-item"
    class:disabled={isLocked}
   role="menuitem"
    aria-label={m.context_menu_forced_subtitle_label()}
    aria-disabled={isLocked}
   href="#!/"
   onclick={markEvents}>
    {m.context_menu_forced_subtitle()}
</a>
